import type { ReactElement } from "react";
import css from "../record.module.css";
import { toVolumePercent } from "./recorderUiRules";

export interface VolumeMeterProps {
  id?: string;
  label: string;
  level: number;
  variant?: "default" | "patient";
  paused?: boolean;
  caption?: string;
  valueText?: string;
  title?: string;
}

export default function VolumeMeter({
  id,
  label,
  level,
  variant = "default",
  paused = false,
  caption,
  valueText,
  title,
}: VolumeMeterProps): ReactElement {
  const percent = toVolumePercent(level);
  const isPatient = variant === "patient";
  const meterClass = paused ? css.volumeMeterPaused : isPatient ? css.volumeMeterBlue : "";
  const levelClass = paused ? css.volumeLevelPaused : isPatient ? css.volumeLevelBlue : "";
  const baseValueText = valueText ?? `${percent} percent`;

  return (
    <div
      id={id}
      className={`${css.volumeMeter} ${meterClass}`}
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      aria-valuetext={paused ? `Recording paused, ${baseValueText}` : valueText}
      title={title}
    >
      <div
        className={`${css.volumeLevel} ${levelClass}`}
        aria-hidden="true"
        style={{ width: `${percent}%` }}
      />
      {caption ? <span className={css.volumeMeterLabel}>{caption}</span> : null}
    </div>
  );
}
